/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  MenuItem,
  Button,
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Tabs,
  Tab,
  Box,
  CircularProgress
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PrintIcon from "@material-ui/icons/Print";
import SearchIcon from "@material-ui/icons/Search";
import moment from "moment";
import "moment/locale/th";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Label } from "reactstrap";
import TSSelect2 from "components/Forms/TSSelect2";
import { FinanceBudgetService } from "_services/financebudget.service";
import BudgetReportPrintModal from "./BudgetReportPrintModal";

moment.locale("th");

const useStyles = makeStyles(theme => ({
  card: {
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    marginBottom: theme.spacing(3),
    overflow: "visible !important"
  },
  filterCard: {
    borderRadius: 8,
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    marginBottom: theme.spacing(3),
    overflow: "visible !important",
    position: "relative",
    zIndex: 30
  },
  tableHeadCell: {
    backgroundColor: "#1e3a8a",
    color: "#ffffff",
    fontWeight: "bold",
    fontSize: "13px"
  },
  subHeadCell: {
    backgroundColor: "#0284c7",
    color: "#ffffff",
    fontWeight: "bold",
    fontSize: "13px"
  },
  sumRow: {
    backgroundColor: "#f1f5f9",
    fontWeight: "bold"
  },
  datetimeInputWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    zIndex: 20,
    "& .rdt": {
      width: "100%",
      position: "relative"
    },
    "& .rdtPicker": {
      position: "absolute",
      top: "calc(100% + 4px)",
      left: 0,
      zIndex: 99999,
      backgroundColor: "#ffffff",
      boxShadow: "0 10px 25px rgba(0,0,0,0.18)",
      borderRadius: "8px",
      border: "1px solid #cbd5e1",
      fontSize: "13px",
      fontFamily: '"Sarabun", "Tahoma", sans-serif',
      "& table": {
        margin: 0
      },
      "& table th, & table td": {
        fontSize: "13px",
        height: "26px",
        padding: "2px"
      },
      "& .rdtSwitch": {
        fontSize: "13px",
        fontWeight: "bold"
      }
    },
    "& input": {
      width: "100%",
      height: "38px",
      borderRadius: "4px",
      border: "1px solid #cbd5e1",
      padding: "8px 12px 8px 36px",
      fontSize: "14px",
      color: "#1e293b",
      backgroundColor: "#ffffff",
      cursor: "pointer",
      boxSizing: "border-box",
      fontFamily: '"Sarabun", "Tahoma", sans-serif',
      "&:hover": {
        borderColor: "#94a3b8"
      },
      "&:focus": {
        outline: "none",
        borderColor: "#2563eb",
        boxShadow: "0 0 0 2px rgba(37,99,235,0.1)"
      }
    }
  },
  datetimeIcon: {
    position: "absolute",
    left: "10px",
    color: "#64748b",
    zIndex: 1,
    pointerEvents: "none",
    fontSize: "1rem"
  }
}));

const getCurrentFiscalYear = () => {
  const now = moment();
  return (now.month() >= 9 ? now.year() + 543 + 1 : now.year() + 543).toString();
};

// ฟังก์ชันจัดกลุ่ม: โครงการ (Header Level 1) -> หมวดจัดซื้อ (Header Level 2) -> หมวดย่อย (Header Level 3) -> รายการ
export const groupPaidItems = (items = []) => {
  const projectMap = new Map();

  (items || []).forEach(item => {
    const projKey =
      item.projectId != null
        ? String(item.projectId)
        : item.projectName
        ? "name_" + item.projectName
        : "no-project";

    if (!projectMap.has(projKey)) {
      projectMap.set(projKey, {
        projectId: item.projectId,
        projectName: item.projectName || "ไม่ระบุโครงการ",
        projectMoney: item.projectMoney,
        projectRemainMoney: item.projectRemainMoney,
        categories: new Map(),
        totalPay: 0
      });
    }

    const proj = projectMap.get(projKey);
    const payVal = parseFloat(item.payMoney) || 0;
    proj.totalPay += payVal;

    const catKey =
      item.categoryId != null
        ? String(item.categoryId)
        : item.categoryName
        ? "name_" + item.categoryName
        : "no-category";

    if (!proj.categories.has(catKey)) {
      proj.categories.set(catKey, {
        categoryId: item.categoryId,
        categoryCode: item.categoryCode,
        categoryName: item.categoryName || "ไม่ระบุหมวดจัดซื้อ",
        subCategories: new Map(),
        totalPay: 0
      });
    }

    const cat = proj.categories.get(catKey);
    cat.totalPay += payVal;

    const subKey =
      item.subCategoryId != null
        ? String(item.subCategoryId)
        : item.subCategoryName
        ? "name_" + item.subCategoryName
        : "no-subcategory";

    if (!cat.subCategories.has(subKey)) {
      cat.subCategories.set(subKey, {
        subCategoryId: item.subCategoryId,
        subCategoryCode: item.subCategoryCode,
        subCategoryName: item.subCategoryName || "ไม่ระบุหมวดย่อย",
        items: [],
        totalPay: 0
      });
    }

    const sub = cat.subCategories.get(subKey);
    sub.totalPay += payVal;
    sub.items.push(item);
  });

  return Array.from(projectMap.values()).map(proj => ({
    ...proj,
    categories: Array.from(proj.categories.values()).map(cat => ({
      ...cat,
      subCategories: Array.from(cat.subCategories.values())
    }))
  }));
};

export default function BudgetReports() {
  const classes = useStyles();

  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [printModalOpen, setPrintModalOpen] = useState(false);

  // Filter params
  const [year, setYear] = useState(() => getCurrentFiscalYear());
  const [years, setYears] = useState([]);
  const [btid, setBtid] = useState("");
  const [budgetTypes, setBudgetTypes] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // Report data states
  const [paidItems, setPaidItems] = useState([]);
  const [pendingItems, setPendingItems] = useState([]);
  const [activitySummary, setActivitySummary] = useState([]);
  const [categorySummary, setCategorySummary] = useState([]);

  useEffect(() => {
    FinanceBudgetService.getYears().then(res => {
      if (res.data.success) {
        setYears(res.data.data);
        if (res.data.data.length > 0 && !year) setYear(res.data.data[0].value);
      }
    });
  }, []);

  useEffect(() => {
    if (year) {
      FinanceBudgetService.getBudgetTypes(year)
        .then(res => {
          if (res.data.success) {
            setBudgetTypes(res.data.data || []);
          }
        })
        .catch(err => {
          console.error("Load budget types error:", err);
          setBudgetTypes([]);
        });
    } else {
      setBudgetTypes([]);
    }
  }, [year]);

  useEffect(() => {
    loadActiveReport();
  }, [activeTab, year, btid]);

  const loadActiveReport = async () => {
    setLoading(true);
    try {
      const btidParam = btid ? parseInt(btid, 10) : null;
      if (activeTab === 0) {
        const res = await FinanceBudgetService.getPaidReport(
          year,
          btidParam,
          fromDate || null,
          toDate || null
        );
        if (res.data.success) setPaidItems(res.data.data);
      } else if (activeTab === 1) {
        const res = await FinanceBudgetService.getPendingReport(
          year,
          btidParam,
          fromDate || null,
          toDate || null
        );
        if (res.data.success) setPendingItems(res.data.data);
      } else if (activeTab === 2) {
        const res = await FinanceBudgetService.getActivityReport(year);
        if (res.data.success) setActivitySummary(res.data.data);
      } else if (activeTab === 3) {
        const res = await FinanceBudgetService.getCategoryReport(year);
        if (res.data.success) setCategorySummary(res.data.data);
      }
    } catch (err) {
      console.error("Load report error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = () => {
    setPrintModalOpen(true);
  };

  return (
    <div>
      <Card className={classes.filterCard}>
        <CardContent style={{ overflow: "visible" }}>
          <Grid container spacing={2} alignItems="center">
            <Grid
              item
              xs={12}
              sm={6}
              md={activeTab <= 1 ? 2 : 4}
              style={{ position: "relative", zIndex: 40 }}
            >
              <TSSelect2
                zIndex={40}
                fontSize="14px"
                label="ปีงบประมาณ"
                options={years}
                value={year}
                onChange={opt => {
                  setYear(opt ? opt.value : "");
                  setBtid("");
                }}
                isClearable={false}
              />
            </Grid>

            {activeTab <= 1 && (
              <>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={3}
                  style={{ position: "relative", zIndex: 35 }}
                >
                  <TSSelect2
                    zIndex={35}
                    fontSize="14px"
                    label="ประเภทงบประมาณ"
                    options={[
                      { value: "", label: "-- ทุกประเภทงบประมาณ --" },
                      ...budgetTypes
                    ]}
                    value={btid}
                    onChange={opt => setBtid(opt ? opt.value : "")}
                    isClearable={false}
                    placeholder="-- ทุกประเภทงบประมาณ --"
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2}
                  style={{ position: "relative", zIndex: 30 }}
                >
                  <Label
                    style={{
                      fontWeight: 500,
                      fontSize: "14px",
                      color: "#334155",
                      marginBottom: 6,
                      display: "inline-block"
                    }}
                  >
                    {activeTab === 0 ? "ตั้งแต่วันที่เบิกจ่าย" : "ตั้งแต่วันที่"}
                  </Label>
                  <div className={classes.datetimeInputWrapper}>
                    <i className={`far fa-calendar-alt ${classes.datetimeIcon}`} />
                    <Datetime
                      value={fromDate ? moment(fromDate) : null}
                      dateFormat="DD/MM/BBBB"
                      timeFormat={false}
                      closeOnSelect={true}
                      renderYear={(props, year) => <td {...props}>{year + 543}</td>}
                      inputProps={{
                        placeholder: "วว/ดด/ปปปป",
                        "aria-label":
                          activeTab === 0
                            ? "ตั้งแต่วันที่เบิกจ่าย"
                            : "ตั้งแต่วันที่"
                      }}
                      onChange={m => {
                        if (moment.isMoment(m)) {
                          setFromDate(m.format("YYYY-MM-DD"));
                        } else if (typeof m === "string") {
                          setFromDate(m);
                        } else if (!m) {
                          setFromDate("");
                        }
                      }}
                    />
                  </div>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={2}
                  style={{ position: "relative", zIndex: 20 }}
                >
                  <Label
                    style={{
                      fontWeight: 500,
                      fontSize: "14px",
                      color: "#334155",
                      marginBottom: 6,
                      display: "inline-block"
                    }}
                  >
                    {activeTab === 0 ? "ถึงวันที่เบิกจ่าย" : "ถึงวันที่"}
                  </Label>
                  <div className={classes.datetimeInputWrapper}>
                    <i className={`far fa-calendar-alt ${classes.datetimeIcon}`} />
                    <Datetime
                      value={toDate ? moment(toDate) : null}
                      dateFormat="DD/MM/BBBB"
                      timeFormat={false}
                      closeOnSelect={true}
                      renderYear={(props, year) => <td {...props}>{year + 543}</td>}
                      inputProps={{
                        placeholder: "วว/ดด/ปปปป",
                        "aria-label":
                          activeTab === 0 ? "ถึงวันที่เบิกจ่าย" : "ถึงวันที่"
                      }}
                      onChange={m => {
                        if (moment.isMoment(m)) {
                          setToDate(m.format("YYYY-MM-DD"));
                        } else if (typeof m === "string") {
                          setToDate(m);
                        } else if (!m) {
                          setToDate("");
                        }
                      }}
                    />
                  </div>
                </Grid>
              </>
            )}

            <Grid
              item
              xs={12}
              sm={12}
              md={activeTab <= 1 ? 3 : 4}
              style={{
                display: "flex",
                gap: "8px",
                position: "relative",
                zIndex: 10,
                alignSelf: "flex-end",
                marginBottom: 2
              }}
            >
              <Button
                variant="contained"
                color="primary"
                startIcon={<SearchIcon />}
                onClick={loadActiveReport}
                style={{ height: 38, fontSize: "14px" }}
              >
                ดึงรายงาน
              </Button>
              <Button
                variant="outlined"
                color="default"
                startIcon={<PrintIcon />}
                onClick={handlePrint}
                style={{ height: 38, fontSize: "14px" }}
              >
                พิมพ์
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Paper className={classes.card}>
        <Tabs
          value={activeTab}
          onChange={(e, v) => setActiveTab(v)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="1. ใบกันเงินที่เบิกจ่ายแล้ว" />
          <Tab label="2. ใบกันเงินที่ยังไม่เบิกจ่าย" />
          <Tab label="3. สรุปตามกิจกรรม" />
          <Tab label="4. สรุปตามหมวดหมู่ค่าใช้จ่าย" />
        </Tabs>

        <Box p={2}>
          {loading ? (
            <Box p={4} textAlign="center">
              <CircularProgress />
              <Typography style={{ marginTop: 16 }}>
                กำลังประมวลผลรายงาน...
              </Typography>
            </Box>
          ) : activeTab === 0 ? (
            /* Report 1: ใบกันเบิกจ่ายแล้ว (จัดกลุ่ม โครงการ -> หมวดจัดซื้อ -> หมวดย่อย) */
            <div>
              <Typography
                variant="h6"
                style={{ fontWeight: "bold", marginBottom: 12 }}
              >
                รายงานใบกันเงินที่เบิกจ่ายแล้ว (ปีงบประมาณ {year})
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeadCell} style={{ width: "55%" }}>
                      โครงการ / หมวดจัดซื้อ / เลขที่ใบกันเงิน
                    </TableCell>
                    <TableCell className={classes.tableHeadCell} align="center" style={{ width: "25%" }}>
                      วันที่เบิกจ่าย
                    </TableCell>
                    <TableCell className={classes.tableHeadCell} align="right" style={{ width: "20%" }}>
                      จำนวนเงิน (บาท)
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paidItems.length > 0 ? (
                    groupPaidItems(paidItems).map((proj, pIdx) => (
                      <React.Fragment key={proj.projectId || `proj-${pIdx}`}>
                        {/* Header Level 1: รหัสโครงการ ชื่อโครงการ ยอดรวมโครงการ */}
                        <TableRow style={{ backgroundColor: "#5670ae" }}>
                          <TableCell colSpan={2} style={{ color: "#ffffff", padding: "10px 16px" }}>
                            <div style={{ fontWeight: "bold", fontSize: "15px", display: "flex", alignItems: "center", gap: "8px" }}>
                              {proj.projectId && (
                                <span style={{ backgroundColor: "#38bdf8", color: "#0f172a", padding: "2px 8px", borderRadius: "4px", fontSize: "13px" }}>
                                  {proj.projectId}
                                </span>
                              )}
                              <span>{proj.projectName}</span>
                            </div>
                            {(proj.projectMoney != null || proj.projectRemainMoney != null) && (
                              <div style={{ fontSize: "12px", color: "#dae1e9", marginTop: "4px", paddingLeft: proj.projectId ? "36px" : "0" }}>
                                {proj.projectMoney != null && (
                                  <span>เงินที่ได้รับจัดสรร {Number(proj.projectMoney).toLocaleString("th-TH", { minimumFractionDigits: 2 })} ฿ &nbsp;&nbsp;&nbsp;&nbsp;</span>
                                )}
                                {proj.projectRemainMoney != null && (
                                  <span>คงเหลือ {Number(proj.projectRemainMoney).toLocaleString("th-TH", { minimumFractionDigits: 2 })} ฿</span>
                                )}
                              </div>
                            )}
                          </TableCell>
                          <TableCell align="right" style={{ color: "#38bdf8", fontWeight: "bold", fontSize: "15px", verticalAlign: "middle" }}>
                            {Number(proj.totalPay).toLocaleString("th-TH", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}
                          </TableCell>
                        </TableRow>

                        {/* Header Level 2: รหัสหมวด ชื่อหมวดจัดซื้อ ยอดรวมหมวดจัดซื้อ */}
                        {proj.categories.map((cat, cIdx) => (
                          <React.Fragment key={cat.categoryId || `cat-${cIdx}`}>
                            <TableRow style={{ backgroundColor: "#e2e8f0" }}>
                              <TableCell colSpan={2} style={{ paddingLeft: "32px", fontWeight: "bold", color: "#1e293b", fontSize: "14px" }}>
                                {cat.categoryName}{cat.categoryCode ? `- ${cat.categoryCode}` : ""}
                              </TableCell>
                              <TableCell align="right" style={{ fontWeight: "bold", color: "#0f172a", fontSize: "14px" }}>
                                {Number(cat.totalPay).toLocaleString("th-TH", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                })}
                              </TableCell>
                            </TableRow>

                            {/* Header Level 3: รหัสหมวดย่อย หมวดย่อย ยอดรวมหมวดย่อย */}
                            {cat.subCategories.map((sub, sIdx) => (
                              <React.Fragment key={sub.subCategoryId || `sub-${sIdx}`}>
                                <TableRow style={{ backgroundColor: "#f8fafc" }}>
                                  <TableCell colSpan={2} style={{ paddingLeft: "48px", fontWeight: 600, color: "#334155", fontSize: "13px" }}>
                                    - {sub.subCategoryName}{sub.subCategoryCode ? `- ${sub.subCategoryCode}` : ""}
                                  </TableCell>
                                  <TableCell align="right" style={{ fontWeight: "bold", color: "#334155", fontSize: "13px" }}>
                                    {Number(sub.totalPay).toLocaleString("th-TH", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    })}
                                  </TableCell>
                                </TableRow>

                                {/* ภายในตาราง: เลขที่ใบกันเงิน วันที่เบิกจ่าย จำนวนเงิน */}
                                {sub.items.map((item, itemIdx) => (
                                  <TableRow key={item.id || itemIdx} hover style={{ backgroundColor: "#ffffff" }}>
                                    <TableCell style={{ paddingLeft: "68px", color: "#1e293b" }}>
                                      <span style={{ fontWeight: 500 }}>{item.number}</span>
                                      {item.companyName && (
                                        <span style={{ color: "#64748b", fontSize: "12px", marginLeft: "8px" }}>
                                          ({item.companyName})
                                        </span>
                                      )}
                                    </TableCell>
                                    <TableCell align="center" style={{ color: "#334155" }}>
                                      {item.datePay
                                        ? moment(item.datePay).locale("th").add(543, "years").format("D MMMM YYYY")
                                        : "-"}
                                    </TableCell>
                                    <TableCell align="right" style={{ color: "#16a34a", fontWeight: "bold" }}>
                                      {Number(item.payMoney || 0).toLocaleString("th-TH", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                      })}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </React.Fragment>
                            ))}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={3}
                        align="center"
                        style={{ padding: 30, color: "#94a3b8" }}
                      >
                        ไม่พบข้อมูลในรอบนี้
                      </TableCell>
                    </TableRow>
                  )}
                  {paidItems.length > 0 && (
                    <TableRow className={classes.sumRow} style={{ backgroundColor: "#f1f5f9" }}>
                      <TableCell colSpan={2} align="right" style={{ fontWeight: "bold", fontSize: "15px" }}>
                        ยอดรวมการเบิกจ่ายทั้งสิ้น ({paidItems.length} รายการ):
                      </TableCell>
                      <TableCell align="right" style={{ color: "#16a34a", fontWeight: "bold", fontSize: "16px" }}>
                        {paidItems
                          .reduce((acc, c) => acc + (c.payMoney || 0), 0)
                          .toLocaleString("th-TH", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          ) : activeTab === 1 ? (
            /* Report 2: ใบกันยังไม่เบิกจ่าย */
            <div>
              <Typography
                variant="h6"
                style={{ fontWeight: "bold", marginBottom: 12 }}
              >
                รายงานใบกันเงินที่ยังไม่เบิกจ่าย / คงค้าง (ปีงบประมาณ {year})
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeadCell} align="center">
                      #
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                      เลขที่ใบกันเงิน
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                      โครงการ
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                      หมวดจัดซื้อ
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                      บริษัท/ผู้ขาย
                    </TableCell>
                    <TableCell className={classes.tableHeadCell} align="center">
                      ลงวันที่
                    </TableCell>
                    <TableCell className={classes.tableHeadCell} align="right">
                      ยอดกันเงิน
                    </TableCell>
                    <TableCell className={classes.tableHeadCell} align="right">
                      เบิกจ่ายแล้วบางส่วน
                    </TableCell>
                    <TableCell className={classes.tableHeadCell} align="right">
                      ยอดคงค้างรอเบิก
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pendingItems.length > 0 ? (
                    pendingItems.map((item, idx) => (
                      <TableRow key={item.id} hover>
                        <TableCell align="center">{idx + 1}</TableCell>
                        <TableCell
                          style={{ fontWeight: "bold", color: "#1e3a8a" }}
                        >
                          {item.number}
                        </TableCell>
                        <TableCell>{item.projectName || "-"}</TableCell>
                        <TableCell>{item.categoryName || "-"}</TableCell>
                        <TableCell>{item.companyName || "-"}</TableCell>
                        <TableCell align="center">
                          {item.kDate
                            ? moment(item.kDate)
                                .add(543, "years")
                                .format("DD/MM/YYYY")
                            : "-"}
                        </TableCell>
                        <TableCell align="right">
                          {item.protectMoney.toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                        </TableCell>
                        <TableCell align="right" style={{ color: "#0284c7" }}>
                          {item.totalPaidSoFar.toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                        </TableCell>
                        <TableCell
                          align="right"
                          style={{ color: "#dc2626", fontWeight: "bold" }}
                        >
                          {item.pendingBalance.toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={9}
                        align="center"
                        style={{ padding: 30, color: "#94a3b8" }}
                      >
                        ไม่มีรายการคงค้างรอเบิกจ่าย
                      </TableCell>
                    </TableRow>
                  )}
                  {pendingItems.length > 0 && (
                    <TableRow className={classes.sumRow}>
                      <TableCell colSpan={6} align="right">
                        รวมทั้งสิ้น ({pendingItems.length} รายการ):
                      </TableCell>
                      <TableCell align="right">
                        {pendingItems
                          .reduce((acc, c) => acc + c.protectMoney, 0)
                          .toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                      </TableCell>
                      <TableCell align="right">
                        {pendingItems
                          .reduce((acc, c) => acc + c.totalPaidSoFar, 0)
                          .toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                      </TableCell>
                      <TableCell align="right" style={{ color: "#dc2626" }}>
                        {pendingItems
                          .reduce((acc, c) => acc + c.pendingBalance, 0)
                          .toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          ) : activeTab === 2 ? (
            /* Report 3: สรุปตามกิจกรรม */
            <div>
              <Typography
                variant="h6"
                style={{ fontWeight: "bold", marginBottom: 12 }}
              >
                รายงานสรุปงบประมาณแยกตามกิจกรรม (ปีงบประมาณ {year})
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.subHeadCell} align="center">
                      #
                    </TableCell>
                    <TableCell className={classes.subHeadCell}>
                      กิจกรรม
                    </TableCell>
                    <TableCell className={classes.subHeadCell} align="center">
                      จำนวนใบกันเงิน
                    </TableCell>
                    <TableCell className={classes.subHeadCell} align="right">
                      ยอดกันเงินรวม (บาท)
                    </TableCell>
                    <TableCell className={classes.subHeadCell} align="right">
                      ยอดเบิกจ่ายแล้ว (บาท)
                    </TableCell>
                    <TableCell className={classes.subHeadCell} align="right">
                      ยอดคงเหลือรอเบิก (บาท)
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {activitySummary.length > 0 ? (
                    activitySummary.map((item, idx) => (
                      <TableRow key={item.aid} hover>
                        <TableCell align="center">{idx + 1}</TableCell>
                        <TableCell style={{ fontWeight: "500" }}>
                          {item.activityName}
                        </TableCell>
                        <TableCell align="center">
                          {item.protectCount}
                        </TableCell>
                        <TableCell align="right" style={{ fontWeight: "bold" }}>
                          {item.totalProtectMoney.toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                        </TableCell>
                        <TableCell align="right" style={{ color: "#16a34a" }}>
                          {item.totalPaidMoney.toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                        </TableCell>
                        <TableCell align="right" style={{ color: "#dc2626" }}>
                          {item.totalPendingMoney.toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        align="center"
                        style={{ padding: 30, color: "#94a3b8" }}
                      >
                        ไม่พบข้อมูล
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          ) : (
            /* Report 4: สรุปตามหมวดหมู่ */
            <div>
              <Typography
                variant="h6"
                style={{ fontWeight: "bold", marginBottom: 12 }}
              >
                รายงานสรุปงบประมาณแยกตามหมวดหมู่ค่าใช้จ่าย (ปีงบประมาณ {year})
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.subHeadCell} align="center">
                      #
                    </TableCell>
                    <TableCell className={classes.subHeadCell}>
                      หมวดหมู่ค่าใช้จ่าย
                    </TableCell>
                    <TableCell className={classes.subHeadCell} align="center">
                      จำนวนรายการ
                    </TableCell>
                    <TableCell className={classes.subHeadCell} align="right">
                      ยอดเงินกันรวม (บาท)
                    </TableCell>
                    <TableCell className={classes.subHeadCell} align="right">
                      ยอดเบิกจ่ายแล้ว (บาท)
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {categorySummary.length > 0 ? (
                    categorySummary.map((item, idx) => (
                      <TableRow key={item.cid} hover>
                        <TableCell align="center">{idx + 1}</TableCell>
                        <TableCell style={{ fontWeight: "500" }}>
                          {item.categoryName}
                        </TableCell>
                        <TableCell align="center">
                          {item.protectCount}
                        </TableCell>
                        <TableCell align="right" style={{ fontWeight: "bold" }}>
                          {item.totalProtectMoney.toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                        </TableCell>
                        <TableCell align="right" style={{ color: "#16a34a" }}>
                          {item.totalPaidMoney.toLocaleString("th-TH", {
                            minimumFractionDigits: 2
                          })}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        align="center"
                        style={{ padding: 30, color: "#94a3b8" }}
                      >
                        ไม่พบข้อมูล
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          )}
        </Box>
      </Paper>

      {/* A4 Print Preview Modal */}
      <BudgetReportPrintModal
        open={printModalOpen}
        onClose={() => setPrintModalOpen(false)}
        reportType={activeTab}
        year={year}
        budgetTypeName={
          budgetTypes.find(b => String(b.value) === String(btid))?.label || ""
        }
        fromDate={fromDate}
        toDate={toDate}
        data={
          activeTab === 0
            ? paidItems
            : activeTab === 1
            ? pendingItems
            : activeTab === 2
            ? activitySummary
            : categorySummary
        }
      />
    </div>
  );
}
